// AdminLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import AppToaster from './components/AppToaster';
import { AdminMenu } from './components/AdminMenu';

const AdminLayout: React.FC = () => {

  return (
    <div className="flex min-h-screen w-full flex-col bg-background">
      <Header />
      {/* This is the new layout from Option 1.
        It's a flex container that splits the sidebar and the main content.
        'flex-1' makes this container fill the remaining vertical space.
      */}
      <div className="flex flex-1 border-t">
        {/* The AdminMenu is now the desktop sidebar. 
          It will be hidden on mobile by its own internal logic.
        */}
        <AdminMenu />

        {/* This <main> area is now the scrolling part of the page.
          'flex-1' makes it fill the remaining horizontal space.
          'overflow-y-auto' makes only this area scroll.
        */}
        <main className="flex-1 overflow-y-auto bg-muted/40 p-4 md:p-10">
          {/* The content from the old <main> (title + outlet) now lives
            inside this new scrolling <main>.
          */}
          <div className="mx-auto grid w-full max-w-6xl gap-4 md:gap-8">

            {/* Outlet Content */}
            <div className="grid gap-6">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
      <AppToaster />
    </div>
  );
};

export default AdminLayout;